module.exports = __webpack_public_path__ + "static/media/job_category_19.a4d50270.png";